import { TrackerType } from '@vae/server/dist/client'

export const getColor = (trackerType: TrackerType) => {
	switch (trackerType) {
		case 'veryLow':
			return '#19B338'
		case 'veryHigh':
			return '#FF193B'
		case 'low':
			return '#23DF48'
		case 'high':
			return '#FFB30D'
		default:
			return '#5C95FF'
	}
}
